import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ENVIRONMENT } from '@env/environment.model';
import { SessionExit } from '@app/core/session/session-exit';
import { isSessionExpired } from './http-error';
import { isApiRequest } from './is-api-request';

/**
 * El token venció a mitad del flujo (ej. mientras el cliente carga documentos): cierra la sesión como `expired`.
 * `SessionExit` solo actúa con el RFC ya validado: antes de eso el 401 lo resuelven `onboardingAccessGuard` o la
 * página del RFC, y navegar desde acá pisaría su navegación. Varias requests con 401 a la vez salen una sola vez.
 * El error se re-lanza igual, para que quien hizo la request cierre lo suyo (finalize, colas, etc.).
 */
export const sessionExpiredInterceptor: HttpInterceptorFn = (req, next) => {
  const exit = inject(SessionExit);
  const apiUrl = inject(ENVIRONMENT).apiUrl;

  return next(req).pipe(
    catchError((error: unknown) => {
      if (isSessionExpired(error) && isApiRequest(req, apiUrl)) {
        exit.end('expired');
      }
      return throwError(() => error);
    }),
  );
};
